export type IProjectState = {
    id: number;
    name: string;
}

export enum IProjectActionTypes {
    FETCH_PROJECT_LIST_REQUEST = 'FETCH_PROJECT_LIST_REQUEST',
    FETCH_PROJECT_LIST_SUCCESS = 'FETCH_PROJECT_LIST_SUCCESS',
    FETCH_PROJECT_LIST_FAILURE = 'FETCH_PROJECT_LIST_FAILURE',

}

export type IProjectActionCreator = {
    type: string;
    payload: IProjectState;
  };
